module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-5-278c51b6d26da77ad2eb678990b63caa.png";